require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-code-fellows-wins-wtia-dei-award.json") })
        }
      }, "path---blog-code-fellows-wins-wtia-dei-award");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-code-fellows-wins-wtia-dei-award!./.cache/json/blog-code-fellows-wins-wtia-dei-award.json
// module id = 782
// module chunks = 231608221292675